<template>
    <o-form :title="$t('core.user_region')"
            :url="'/api/system/regions/' + $route.params.id"
            class="ortic-form-horizontal">
      <template slot-scope="props">
        <b-row>
          <b-col>
            <o-input :label="$t('core.region')" v-model="props.item.region"/>
          </b-col>
          <b-col>
            <o-value-select-modal :label="$t('core.team_head')"
                            v-model="props.item.user_id"
                            url="/api/system/users"
                            display-field="name">
              <template slot="filter" slot-scope="controlProps">
                <o-filter v-on:filter-updated="(filters) => controlProps.setFilters(filters)" :default-filter="defaultFilters">
                  <o-filter-text :title="$t('core.name')" column="name"></o-filter-text>
                  <o-filter-text :title="$t('core.email')" column="email"></o-filter-text>
                  <o-filter-select :title="$t('core.status')" column="active" :items="statusOptions"></o-filter-select>
                </o-filter>
              </template>
              <template slot="head">
                <o-table-header column="name">{{$t('core.name')}}</o-table-header>
                <o-table-header column="email">{{$t('core.email')}}</o-table-header>
              </template>
              <template slot="body" slot-scope="userProps">
                <td>{{ userProps.item.name }}</td>
                <td>{{ userProps.item.email }}</td>
              </template>
            </o-value-select-modal>
          </b-col>
        </b-row>
      </template>
    </o-form>
  </template>
<script>
export default {
  data () {
    return {
      statusOptions: [
        { value: 1, text: this.$t('core.active') },
        { value: 0, text: this.$t('core.inactive') }
      ],
      defaultFilters: [
        {
          column: 'active',
          title: this.$t('core.status'),
          value: 1,
          displayValue: this.$t('core.active')
        }
      ]
    }
  }
}
</script>
